import type {
    PhotosPagePropertyOnboardingContextFieldsV2,
    PhotosPagePropertyOnboardingContextIdsV2,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    AddPhotosElementPropertyOnboardingManifestV1,
    CarouselInspirationPhotoElementPropertyOnboardingManifestV1,
    ConfirmDeletePhotoElementPropertyOnboardingManifestV1,
    ContentPolicyElementPropertyOnboardingManifestV1,
    DeletePhotoElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    PhotoTipsElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
    SetMainPhotoElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    PhotosPagePropertyOnboardingContextManifestV2,
    WebListYourPropertyPhotosVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/photos-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const photosBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<PhotosPagePropertyOnboardingContextIdsV2, PhotosPagePropertyOnboardingContextFieldsV2>(
        PhotosPagePropertyOnboardingContextManifestV2.ids,
        {
            auth_user_id: BaseContextFieldsMapping.auth_user_id,
            member_id: BaseContextFieldsMapping.member_id,
            property_id: BaseContextFieldsMapping.property_id,
            onboarding_id: BaseContextFieldsMapping.onboarding_id,
            is_internal_user: BaseContextFieldsMapping.is_internal_user,
        },
    );

    webAnalytics.observe(WebListYourPropertyPhotosVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], AddPhotosElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], PhotoTipsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], CarouselInspirationPhotoElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "photo-id"),
    });
    webAnalytics.observeElement([click], DeletePhotoElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ConfirmDeletePhotoElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], SetMainPhotoElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], ContentPolicyElementPropertyOnboardingManifestV1.ids, {});
});
